module.exports = __webpack_public_path__ + "static/img/m10.01e0482.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/m10.png
// module id = i27g
// module chunks = 3